<template>
    <div>
        <pre>
            源代码如下
            最新版本v2.10.9新增特性‘Tab: 当标签页内容为空时，不再渲染空的 van-tab-pane 节点’
当部分tab为空并使用animated动画时， vant不会渲染空tab，但是动画会计算此tab的位置，导致切换过程的tab错位问题，
当切换到tab 2时，由于tab1为空所以不渲染，但是动画依然计算了tab1的位置，所以对tab2应用transform: translate(-100%)，导致tab2错位不显示。
            <div v-text="text"></div>
        </pre>
        <van-tabs
                v-model="tabName"
                animated>
            <van-tab title="1" name="first">
                <div v-if="tabName === 'first'">1</div>
            </van-tab>
            <van-tab title="2" name="second">
                <div v-if="tabName === 'second'">2</div>
            </van-tab>
            <van-tab title="3" name="third">
                <div v-if="tabName === 'third'">3</div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { Tabs, Tab } from 'vant'// v2.10.9
import 'vant/lib/index.css'
export default {
  name: '',
  mixins: [],
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab
  },
  props: {},
  data () {
    return {
      text: `<van-tabs
                    v-model="tabName"
                    animated>
            <van-tab title="1" name="first">
                <div v-if="tabName === 'first'">1</div>
            </van-tab>
            <van-tab title="2" name="second">
                <div v-if="tabName === 'second'">2</div>
            </van-tab>
            <van-tab title="3" name="third">
                <div v-if="tabName === 'third'">3</div>
            </van-tab>
        </van-tabs>`,
      tabName: 'first'
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>

</style>
